export function scrollToElementIfNotInView(
  element: Element | null,
  options?: ScrollIntoViewOptions,
  inParentView?: boolean,
) {
  /**
   * https://www.javascripttutorial.net/dom/css/check-if-an-element-is-visible-in-the-viewport/
   */
  if (element) {
    const rect = element.getBoundingClientRect();

    const windowBounds: Pick<DOMRect, 'top' | 'bottom' | 'left' | 'right'> =
      window.innerHeight && window.innerWidth
        ? {
            top: 0,
            left: 0,
            bottom: window.innerHeight,
            right: window.innerWidth,
          }
        : document.documentElement.getBoundingClientRect();
    const bounds: Pick<DOMRect, 'top' | 'bottom' | 'left' | 'right'> =
      (inParentView && element.parentElement?.getBoundingClientRect()) ||
      windowBounds;

    const isInView =
      rect.top >= bounds.top &&
      rect.left >= bounds.left &&
      rect.bottom <= bounds.bottom &&
      rect.right <= bounds.right;
    if (typeof element !== 'undefined' && element !== null && !isInView) {
      element?.scrollIntoView(options);
    }
  }
}

// In certain cases the parent element may be within a scrollable container and
// its bounds may extend beyond that of its parent. To fix this, the parent element
// whose bounds more accurately reflect the visibility of the scrolled-to element
// should be passed into this function.
export function scrollToElementIfNotInBoundsOfParent(
  element: Element | null,
  parentElement: Element | null,
  options?: ScrollIntoViewOptions,
) {
  /**
   * https://www.javascripttutorial.net/dom/css/check-if-an-element-is-visible-in-the-viewport/
   */
  if (element && parentElement) {
    const rect = element.getBoundingClientRect();

    const windowBounds: Pick<DOMRect, 'top' | 'bottom' | 'left' | 'right'> =
      window.innerHeight && window.innerWidth
        ? {
            top: 0,
            left: 0,
            bottom: window.innerHeight,
            right: window.innerWidth,
          }
        : document.documentElement.getBoundingClientRect();
    const bounds: Pick<DOMRect, 'top' | 'bottom' | 'left' | 'right'> =
      parentElement?.getBoundingClientRect() || windowBounds;

    const isInView =
      rect.top >= bounds.top &&
      rect.left >= bounds.left &&
      rect.bottom <= bounds.bottom &&
      rect.right <= bounds.right;
    if (typeof element !== 'undefined' && element !== null && !isInView) {
      element?.scrollIntoView(options);
    }
  }
}

export function scrollToIfNotInView(elementSelector: string | null) {
  scrollToElementIfNotInView(
    elementSelector === null ? null : document.querySelector(elementSelector),
  );
}

export function scrollTo(elementSelector: string | null) {
  if (elementSelector) {
    const el = document.querySelector(elementSelector);
    if (typeof el !== 'undefined' && el !== null) {
      el?.scrollIntoView();
    }
  }
}
